import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../utils/firebase";
import { APP_VERSION } from "../../version";

const VersionManager: React.FC = () => {
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const versionRef = doc(db, "appConfig", "version");
    
    const unsubscribe = onSnapshot(versionRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        if (data.currentVersion && data.currentVersion !== APP_VERSION) {
          console.log(`[VersionManager] Version mismatch! App: ${APP_VERSION}, Server: ${data.currentVersion}`);
          triggerUpdate();
        }
      }
    }, (error) => {
      console.error("[VersionManager] Failed to listen to version changes", error);
    });

    return () => unsubscribe();
  }, []);

  const triggerUpdate = () => {
    setIsUpdating(true);
    
    // Aggressive Cache Clearing
    try {
      if ('caches' in window) {
        caches.keys().then((names) => {
          for (let name of names) caches.delete(name);
        });
      }
      
      // Attempt to unregister service workers which aggressively cache SPAs
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(function(registrations) {
          for(let registration of registrations) {
            registration.unregister();
          }
        });
      }
    } catch (e) {
      console.error("Cache clear error", e);
    }

    // Force hard reload after brief delay to show UI
    setTimeout(() => {
      window.location.href = window.location.pathname + "?v=" + new Date().getTime();
    }, 1500);
  };

  if (!isUpdating) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.9)',
      zIndex: 999999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontFamily: 'sans-serif'
    }}>
      <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px' }}>
        App Update Required
      </h2>
      <p style={{ opacity: 0.8, marginBottom: '24px' }}>
        A new version has been deployed. Reloading automatically...
      </p>
      <div style={{
        width: '40px',
        height: '40px',
        border: '4px solid rgba(255,255,255,0.2)',
        borderTop: '4px solid #f59e0b',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }} />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default VersionManager;
